import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';

const TechnicalSEOArticle = () => {
  useSEO({
    title: 'Technical SEO Audits NYC | Performance & Speed Optimization',
    description: 'Advanced NYC Technical SEO services. We optimize Core Web Vitals, site architecture, and code for maximum Google ranking and crawl efficiency.',
  });

  return (
    <div className="pt-20 pb-24 bg-slate-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Technical Dominance" 
            title="Technical SEO: The Foundation of Search Ranking" 
          />
        </AnimatedSection>
        
        <div className="prose prose-invert prose-lg max-w-none text-slate-300 space-y-8">
          <p className="text-xl text-white font-medium leading-relaxed">
            In the hyper-competitive NYC market, a beautiful website is useless if search engines can't crawl it effectively or if it takes five seconds to load on a mobile device in a subway station.
          </p>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Why Technical SEO Matters in NYC</h3>
            <p>
              Google uses complex crawlers to analyze your site's infrastructure. If your code is bloated, your images are unoptimized, or your internal linking is a maze, your rankings will suffer regardless of how good your content is. Our technical audits go beyond the basics.
            </p>
          </section>

          <div className="bg-slate-900 p-8 rounded-2xl border border-blue-500/20 my-10">
            <h4 className="text-blue-400 font-bold mb-4 uppercase tracking-wider">Our Technical Checklist:</h4>
            <ul className="grid md:grid-cols-2 gap-4 list-none p-0">
              <li className="flex items-center space-x-2"><span className="text-blue-500">●</span> <span>Core Web Vitals Optimization</span></li>
              <li className="flex items-center space-x-2"><span className="text-blue-500">●</span> <span>Advanced Schema Markup</span></li>
              <li className="flex items-center space-x-2"><span className="text-blue-500">●</span> <span>XML Sitemap & Robots.txt Tuning</span></li>
              <li className="flex items-center space-x-2"><span className="text-blue-500">●</span> <span>Server Response Time Reduction</span></li>
              <li className="flex items-center space-x-2"><span className="text-blue-500">●</span> <span>HTTPS & Security Hardening</span></li>
              <li className="flex items-center space-x-2"><span className="text-blue-500">●</span> <span>Javascript Rendering Fixes</span></li>
            </ul>
          </div>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Mobile-First Performance</h3>
            <p>
              With over 60% of NYC searches occurring on mobile, we ensure your site passes every mobile-usability test. We optimize for "on-the-go" searchers who demand instant answers.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TechnicalSEOArticle;